import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import Footer from "../../components/comunes/Footer";
import { useNavigate } from "react-router-dom";
import { getToken } from "../../utils/auth";
import { Spinner, Badge, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { appendMetaAccountToUrl, useMetaAdAccounts } from "../zocometa/metaAdAccounts";

const MetaCampanas = () => {
    const { darkMode } = useContext(DarkModeContext);
    const navegacion = useNavigate();
    const [cargando, setCargando] = useState(true);
    const [tab, setTab] = useState("campanas");

    const [campanas, setCampanas] = useState([]);
    const [loadingCampanas, setLoadingCampanas] = useState(false);
    const [errorCampanas, setErrorCampanas] = useState(null);

    const [insights, setInsights] = useState([]);
    const [loadingInsights, setLoadingInsights] = useState(false);
    const [errorInsights, setErrorInsights] = useState(null);

    const [adsets, setAdsets] = useState([]);
    const [loadingAdsets, setLoadingAdsets] = useState(false);
    const [errorAdsets, setErrorAdsets] = useState(null);

    const [campanasBD, setCampanasBD] = useState([]);
    const [loadingBD, setLoadingBD] = useState(false);
    const { accounts, selectedAccount, selectedKey, selectAccount, loading: loadingAccounts } = useMetaAdAccounts();

    useEffect(() => {
        const verificar = async () => {
            const token = getToken();
            if (!token) { navegacion("/"); return; }
            try {
                const r = await fetch(process.env.REACT_APP_API_TOKEN, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: token }),
                });
                if (!r.ok) navegacion("/");
            } catch {
                navegacion("/");
            } finally {
                setCargando(false);
            }
        };
        verificar();
    }, [navegacion]);

    const cargarCampanas = async () => {
        setLoadingCampanas(true);
        setErrorCampanas(null);
        try {
            const r = await fetch(appendMetaAccountToUrl("/api/meta/campanas/meta", selectedAccount));
            const data = await r.json();
            if (!r.ok) {
                setErrorCampanas(data.error || `Error ${r.status}`);
                return;
            }
            setCampanas(Array.isArray(data) ? data : []);
        } catch {
            setErrorCampanas("No se pudo conectar con Meta Ads API.");
        } finally {
            setLoadingCampanas(false);
        }
    };

    const cargarInsights = async () => {
        setLoadingInsights(true);
        setErrorInsights(null);
        try {
            const r = await fetch(appendMetaAccountToUrl("/api/meta/campanas/insights", selectedAccount));
            const data = await r.json();
            if (!r.ok) {
                setErrorInsights(data.error || `Error ${r.status}`);
                return;
            }
            setInsights(Array.isArray(data) ? data : []);
        } catch {
            setErrorInsights("No se pudo obtener los insights.");
        } finally {
            setLoadingInsights(false);
        }
    };

    const cargarAdsets = async () => {
        setLoadingAdsets(true);
        setErrorAdsets(null);
        try {
            const r = await fetch(appendMetaAccountToUrl("/api/meta/adsets", selectedAccount));
            const data = await r.json();
            if (!r.ok) {
                setErrorAdsets(data.error || `Error ${r.status}`);
                return;
            }
            setAdsets(Array.isArray(data) ? data : []);
        } catch {
            setErrorAdsets("No se pudo obtener los conjuntos de anuncios.");
        } finally {
            setLoadingAdsets(false);
        }
    };

    const cargarBD = async () => {
        setLoadingBD(true);
        try {
            const r = await fetch("/api/meta/campanas");
            if (!r.ok) return;
            setCampanasBD(await r.json());
        } catch {
            // noop
        } finally {
            setLoadingBD(false);
        }
    };

    useEffect(() => {
        if (cargando || loadingAccounts || !selectedAccount) return;
        cargarCampanas();
        cargarInsights();
        cargarAdsets();
        cargarBD();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cargando, loadingAccounts, selectedKey]);

    if (cargando) return null;

    const cardStyle = {
        borderRadius: 12,
        padding: "18px 22px",
        background: darkMode ? "#2c2f36" : "#fff",
        boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        border: `1px solid ${darkMode ? "#3d4148" : "#e9ecef"}`,
    };
    const thStyle = { backgroundColor: darkMode ? "#2c2c2c" : "#f8f9fa", color: darkMode ? "#fff" : "#000", fontSize: 13, whiteSpace: "nowrap" };
    const tdStyle = { fontSize: 13, verticalAlign: "middle" };

    const ErrorCard = ({ msg }) => (
        <div style={{ ...cardStyle, border: "1px solid #dc3545", borderLeft: "4px solid #dc3545" }}>
            <h6 className="fw-bold text-danger mb-1">Sin datos</h6>
            <p style={{ fontSize: 13, marginBottom: 0 }}>{msg}</p>
        </div>
    );

    return (
        <div className={darkMode ? "bg-dark text-white min-vh-100" : "bg-light min-vh-100"}>
            <div className="container-fluid py-4 px-4">
                <div className="d-flex align-items-center justify-content-between mb-3 gap-3 flex-wrap">
                    <div>
                        <h5 className="mb-1 fw-bold">Campanas</h5>
                        <p className="text-muted mb-0" style={{ fontSize: 13 }}>Rendimiento por campana desde Meta Ads API.</p>
                        <p className="text-muted mb-0" style={{ fontSize: 12 }}>
                            Cuenta publicitaria: {selectedAccount?.name || "Sin cuenta"} {selectedAccount?.adAccountId ? `(${selectedAccount.adAccountId})` : ""}
                        </p>
                    </div>
                    <div className="d-flex gap-2 align-items-center flex-wrap">
                        <select
                            className="form-select form-select-sm"
                            style={{ minWidth: 280 }}
                            value={selectedKey}
                            onChange={(e) => selectAccount(e.target.value)}
                            disabled={loadingAccounts || accounts.length === 0}
                        >
                            {accounts.map((item) => (
                                <option key={item.key} value={item.key}>
                                    {item.name} ({item.adAccountId})
                                </option>
                            ))}
                        </select>
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            onClick={() => { cargarCampanas(); cargarInsights(); cargarAdsets(); cargarBD(); }}
                            disabled={loadingCampanas || loadingInsights || loadingAdsets || !selectedAccount}
                        >
                            <FontAwesomeIcon icon={faRotateRight} /> Actualizar
                        </button>
                    </div>
                </div>

                <Nav variant="tabs" className="mb-3" activeKey={tab} onSelect={setTab}>
                    <Nav.Item>
                        <Nav.Link eventKey="campanas" style={{ fontSize: 13 }}>
                            Campanas{campanas.length > 0 && <Badge bg="primary" className="ms-2">{campanas.length}</Badge>}
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="insights" style={{ fontSize: 13 }}>
                            Insights 30d{insights.length > 0 && <Badge bg="success" className="ms-2">{insights.length}</Badge>}
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="adsets" style={{ fontSize: 13 }}>
                            Conjuntos de anuncios{adsets.length > 0 && <Badge bg="info" className="ms-2">{adsets.length}</Badge>}
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="bd" style={{ fontSize: 13 }}>
                            Leads por campana{campanasBD.length > 0 && <Badge bg="secondary" className="ms-2">{campanasBD.length}</Badge>}
                        </Nav.Link>
                    </Nav.Item>
                </Nav>

                {tab === "campanas" && (
                    loadingCampanas ? <div className="text-center py-5"><Spinner animation="border" /></div>
                        : errorCampanas ? <ErrorCard msg={errorCampanas} />
                            : campanas.length === 0 ? <div style={cardStyle}><p className="text-muted mb-0" style={{ fontSize: 13 }}>No se encontraron campanas.</p></div>
                                : (
                                    <div style={cardStyle}>
                                        <table className="table table-sm table-hover" style={{ fontSize: 13 }}>
                                            <thead>
                                                <tr>
                                                    <th style={thStyle}>ID</th>
                                                    <th style={thStyle}>Nombre</th>
                                                    <th style={thStyle}>Estado</th>
                                                    <th style={thStyle}>Objetivo</th>
                                                    <th style={thStyle}>Presupuesto diario</th>
                                                    <th style={thStyle}>Presupuesto total</th>
                                                    <th style={thStyle}>Inicio</th>
                                                    <th style={thStyle}>Fin</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {campanas.map((c) => (
                                                    <tr key={c.id}>
                                                        <td style={{ ...tdStyle, fontSize: 11 }}><code>{c.id}</code></td>
                                                        <td style={tdStyle}>{c.name}</td>
                                                        <td style={tdStyle}>
                                                            <Badge bg={c.status === "ACTIVE" ? "success" : c.status === "PAUSED" ? "warning" : "secondary"}>{c.status}</Badge>
                                                        </td>
                                                        <td style={tdStyle}>{c.objective || "-"}</td>
                                                        <td style={tdStyle}>{c.daily_budget ? `$${(c.daily_budget / 100).toLocaleString("es-AR")}` : "-"}</td>
                                                        <td style={tdStyle}>{c.lifetime_budget ? `$${(c.lifetime_budget / 100).toLocaleString("es-AR")}` : "-"}</td>
                                                        <td style={tdStyle}>{c.start_time ? new Date(c.start_time).toLocaleDateString("es-AR") : "-"}</td>
                                                        <td style={tdStyle}>{c.stop_time ? new Date(c.stop_time).toLocaleDateString("es-AR") : "-"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )
                )}

                {tab === "insights" && (
                    loadingInsights ? <div className="text-center py-5"><Spinner animation="border" /></div>
                        : errorInsights ? <ErrorCard msg={errorInsights} />
                            : insights.length === 0 ? <div style={cardStyle}><p className="text-muted mb-0" style={{ fontSize: 13 }}>Sin datos de insights en los ultimos 30 dias.</p></div>
                                : (
                                    <div style={cardStyle}>
                                        <table className="table table-sm table-hover" style={{ fontSize: 13 }}>
                                            <thead>
                                                <tr>
                                                    <th style={thStyle}>Campana</th>
                                                    <th style={thStyle}>Clicks</th>
                                                    <th style={thStyle}>Impresiones</th>
                                                    <th style={thStyle}>Alcance</th>
                                                    <th style={thStyle}>Gasto</th>
                                                    <th style={thStyle}>Periodo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {insights.map((ins, i) => (
                                                    <tr key={i}>
                                                        <td style={tdStyle}>{ins.campaign_name || ins.campaign_id}</td>
                                                        <td style={tdStyle}>{(parseInt(ins.clicks, 10) || 0).toLocaleString("es-AR")}</td>
                                                        <td style={tdStyle}>{(parseInt(ins.impressions, 10) || 0).toLocaleString("es-AR")}</td>
                                                        <td style={tdStyle}>{(parseInt(ins.reach, 10) || 0).toLocaleString("es-AR")}</td>
                                                        <td style={tdStyle}><strong>${(parseFloat(ins.spend) || 0).toLocaleString("es-AR", { minimumFractionDigits: 2 })}</strong></td>
                                                        <td style={{ ...tdStyle, fontSize: 11 }}>
                                                            {ins.date_start} - {ins.date_stop}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )
                )}

                {tab === "adsets" && (
                    loadingAdsets ? <div className="text-center py-5"><Spinner animation="border" /></div>
                        : errorAdsets ? <ErrorCard msg={errorAdsets} />
                            : adsets.length === 0 ? <div style={cardStyle}><p className="text-muted mb-0" style={{ fontSize: 13 }}>No se encontraron conjuntos de anuncios.</p></div>
                                : (
                                    <div style={cardStyle}>
                                        <table className="table table-sm table-hover" style={{ fontSize: 13 }}>
                                            <thead>
                                                <tr>
                                                    <th style={thStyle}>ID</th>
                                                    <th style={thStyle}>Nombre</th>
                                                    <th style={thStyle}>Estado</th>
                                                    <th style={thStyle}>Evento de facturacion</th>
                                                    <th style={thStyle}>Objetivo</th>
                                                    <th style={thStyle}>Presupuesto diario</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {adsets.map((a) => (
                                                    <tr key={a.id}>
                                                        <td style={{ ...tdStyle, fontSize: 11 }}><code>{a.id}</code></td>
                                                        <td style={tdStyle}>{a.name}</td>
                                                        <td style={tdStyle}>
                                                            <Badge bg={a.status === "ACTIVE" ? "success" : a.status === "PAUSED" ? "warning" : "secondary"}>{a.status}</Badge>
                                                        </td>
                                                        <td style={tdStyle}>{a.billing_event || "-"}</td>
                                                        <td style={tdStyle}>{a.optimization_goal || "-"}</td>
                                                        <td style={tdStyle}>{a.daily_budget ? `$${(a.daily_budget / 100).toLocaleString("es-AR")}` : "-"}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )
                )}

                {tab === "bd" && (
                    loadingBD ? <div className="text-center py-5"><Spinner animation="border" /></div>
                        : campanasBD.length === 0 ? (
                            <div style={cardStyle}>
                                <p className="text-muted mb-0" style={{ fontSize: 13 }}>Sin leads en base de datos aun.</p>
                            </div>
                        ) : (
                            <div style={cardStyle}>
                                <table className="table table-sm table-hover" style={{ fontSize: 13 }}>
                                    <thead>
                                        <tr>
                                            <th style={thStyle}>Campana ID</th>
                                            <th style={thStyle}>Formulario ID</th>
                                            <th style={thStyle}>Total</th>
                                            <th style={thStyle}>Nuevos</th>
                                            <th style={thStyle}>Contactados</th>
                                            <th style={thStyle}>Seguimiento</th>
                                            <th style={thStyle}>Cerrados</th>
                                            <th style={thStyle}>Sin interes</th>
                                            <th style={thStyle}>Ultimo lead</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {campanasBD.map((c, i) => (
                                            <tr key={i}>
                                                <td style={tdStyle}><code style={{ fontSize: 11 }}>{c.campanaId}</code></td>
                                                <td style={tdStyle}><code style={{ fontSize: 11 }}>{c.formId}</code></td>
                                                <td style={tdStyle}><strong>{c.totalLeads}</strong></td>
                                                <td style={tdStyle}><Badge bg="primary">{c.nuevos}</Badge></td>
                                                <td style={tdStyle}><Badge bg="warning">{c.contactados}</Badge></td>
                                                <td style={tdStyle}><Badge bg="info">{c.enSeguimiento}</Badge></td>
                                                <td style={tdStyle}><Badge bg="success">{c.cerrados}</Badge></td>
                                                <td style={tdStyle}><Badge bg="secondary">{c.sinInteres}</Badge></td>
                                                <td style={tdStyle}>{c.ultimoLead ? new Date(c.ultimoLead).toLocaleDateString("es-AR") : "-"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )
                )}
            </div>
            <Footer />
        </div>
    );
};

export default MetaCampanas;
